import React, {Component, useState, useEffect} from 'react';
import {connect} from 'react-redux';

const NoticeMainContainer = (props) => {

  const [isLoaded, setIsLoaded] = useState(false)
  const [state, setState] = useState({})

  useEffect(() => {

  })

  return (
    <div>
      NoticeMainContainer

    </div>
  )
}

const enhance = connect(
  state => ({
    ...state
  }),
  {}
);

export default enhance(NoticeMainContainer);
